export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10730.a537f4b7.jpg";